export default __webpack_public_path__ + "static/media/6pm.bf504137.png";